export const DELETE_KE_FAMILY_MEMBER_MODAL_NAME =
  'DELETE_KE_FAMILY_MEMBER_MODAL_NAME';
